import run from "../../animate/run";

/**
 * Viewport leave
 * @param {CustomEventProps} event
 */
const viewportleave = (event) => {
  run(event, "leave", false);
};

export default viewportleave;
